export const SCHEME_TERMS_CTA_LABEL = "Learn about terms";
export const SCHEME_TERMS_MODAL_TITLE = "Scheme terms";
export const SCHEME_TERMS_BUTTON_TEXT = "GOT IT";

export type SchemeTerm = {
  title: string;
  description: string;
};

export const SCHEME_TERMS: SchemeTerm[] = [
  {
    title: "Fund Age",
    description: "The amount of time that has passed since the fund was first launched",
  },
  {
    title: "AUM (Assets Under Management)",
    description:
      "The total market value of all the money pooled together by all investors in that specific mutual fund scheme",
  },
  {
    title: "Lock-in Period",
    description:
      "Lock-in period is the minimum time you must keep your money in a fund without selling or withdrawing it",
  },
  {
    title: "Exit Load",
    description:
      "A small fee charged by the fund company if you sell or take your money out before a set time period",
  },
  {
    title: "Expense Ratio",
    description:
      "The yearly fee charged by the fund house to manage your money, which covers operating and administrative costs",
  },
];
